import { useTranslation } from "@/hooks/useTranslation/useTranslation"

/** The "From" line a supplier sees. Not a whole email: the address is the
 *  only thing its setting changes. */
export function SenderPreview({ address }: { address: string | null }) {
  const { translate } = useTranslation()
  return (
    <div className="rounded-lg bg-white px-5 py-4 text-[12.5px] text-[#222] shadow-lg">
      <span className="text-[11px] font-medium text-[#999]">
        {translate("MC_TPL_EMAIL_FROM")}
      </span>
      <div className="font-mono mt-1 text-[13px] text-[#222]">
        {address ?? "—"}
      </div>
    </div>
  )
}
